import { Session } from "@/redux/_session.types"
import { User } from "@/redux/user.types"
import { t } from "i18next"
import { toast } from "react-toastify"

//Copy specific link
export default function copyLink(user: User, _session: Session) {
  navigator.clipboard.writeText(user.getInvitationLink(_session, null, true))
  return toast(t("utils_copy_link_done"))
}
